import { useContext } from 'react';

import { AuthenticationContext } from './AuthenticationContext';
import { PermissionsContext } from './PermissionsContext';
import { SidebarContext } from './SidebarContext';

const useAuthentication = () => useContext(AuthenticationContext);
const usePermissions = () => useContext(PermissionsContext);
const useSidebar = () => useContext(SidebarContext);

export {
  useAuthentication,
  usePermissions,
  useSidebar,
};
